import { createRuntime } from '@livefree/runtime';
import { LoginConfig } from './config';

export const hostRuntime = createRuntime({
  hostConfig: LoginConfig,
});
